import { Button, DatePicker, Input, InputNumber, Table, Transfer, TransferProps, Typography, message } from "antd";
import { AuthService } from "../../services/AuthService";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import TextArea from "antd/es/input/TextArea";
import Card from "../../components/Card";

const { Text } = Typography;

interface RecordType {
    key: string;
    title: string;
    description: string;
    chosen: boolean;
}


const NewPromotion = () => {

    const navigate = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);


    const [promotion, setPromotion] = useState({
        title: null,
        description: null,
        startDate: null,
        endDate: null,
    })

    const [products, setProducts] = useState([]);

    const [selectedProducts, setSelectedProducts] = useState([]);

    const [mockData, setMockData] = useState<RecordType[]>([]);
    const [targetKeys, setTargetKeys] = useState<TransferProps['targetKeys']>([]);

    const savePromotion = async () => {
        setLoading(true);

        
        let { title, description, startDate, endDate } = promotion;
        if (!title || !description || !startDate || !endDate) {
            messageApi.open({
                type: 'error',
                content: 'Ploteso fushat e shenuara me *',
            });
            setLoading(false);
            return;
        }
        if (selectedProducts.length < 1) {
            messageApi.open({
                type: 'error',
                content: 'Zgjedhni se paku nje produkt',
            });
            setLoading(false);
            return;
        }
        let obj = {
            title,
            description,
            startDate,
            endDate,
            promotionItems: selectedProducts.map((item) => ({
                barcode: item?.barcode, 
                price: item?.price.toString()
            })),
        }

        console.log("obj", obj);
        let res = await AuthService.createPromotion(obj)
        

            messageApi.open({
                type: 'success',
                content: 'Vlera u ruajt me sukses',
            });
            setTimeout(() => {
                setLoading(false);
                navigate(`/promotions`);
            }, 1000);
        
        setLoading(false)
    }

    const generateProducts = () => {
        console.log("targetKeys", targetKeys);

        const selectedProducts = targetKeys.map((key: any) => {
            const product = products?.find(el => el.barcode === key);
            console.log("PRODD", product)
            return {
                barcode: key,
                name: product?.name,
                price: 0
            };
        });

        setSelectedProducts(selectedProducts);
    };

    const getProducts = async () => {

        const tempTargetKeys = [];
        const tempMockData = [];

        setLoading(true);


        let res = await AuthService.getProducts({});
        console.log("get products", res);
        if (res) {

            // setProducts(res);


            const tempMockData = res.map((item, i) => {
                const data = {
                    key: item.barcode,
                    title: `${item.barcode} ${item?.description}`,
                    name: item?.description,
                    barcode: item.barcode,
                    description: `description of content${i + 1}`,
                    chosen: i % 2 === 0,
                };

                if (data.chosen) {
                    tempTargetKeys.push({ key: data.key, name: data.title });
                }

                return data;
            });

            setProducts(tempMockData)

        }
        setLoading(false);
    };

    const filterOption = (inputValue: string, option: RecordType) =>
        option.description.indexOf(inputValue) > -1;

    const handleChange: TransferProps['onChange'] = (newTargetKeys) => {
        console.log("new", newTargetKeys)
        setTargetKeys(newTargetKeys);
    };

    const updatePriceByBarcode = (barcode: string, newPrice: number) => {
        console.log("changee", barcode, newPrice)
        setSelectedProducts(prevProducts =>
            prevProducts.map(product =>
                product.barcode === barcode
                    ? { ...product, price: newPrice }
                    : product
            )
        );
    };

    const handleSearch: TransferProps['onSearch'] = (dir, value) => {
        console.log('search:', dir, value);
    };

    useEffect(() => {
        getProducts();
    }, [])

    return (
        <div className="container">
            {contextHolder}
            <div className="row">
                <div className="col-lg-7">
                    <Card title="Te dhenat e promocionit">
                        <form action="">
                            <div className="row">
                                <div className="col-12">
                                    <Text>Titulli i promocionit</Text>
                                    <Input value={promotion?.title} onChange={(e) => setPromotion({ ...promotion, title: e.target.value })} />
                                </div>
                                <div className="col-12 mt-3">
                                    <Text>Pershkrimi i promocionit</Text>
                                    <TextArea value={promotion?.description} onChange={(e) => setPromotion({ ...promotion, description: e.target.value })} />
                                </div>
                                <div className="col-6 mt-3">
                                    <Text className="d-block">Aktiv nga:</Text>
                                    <DatePicker style={{ width: "100%" }} value={promotion?.startDate} onChange={(e) => setPromotion({ ...promotion, startDate: e })} />
                                </div>
                                <div className="col-6 mt-3">
                                    <Text className="d-block">Aktiv deri me:</Text>
                                    <DatePicker minDate={promotion?.startDate} style={{ width: "100%" }} value={promotion?.endDate} onChange={(e) => setPromotion({ ...promotion, endDate: e })} />
                                </div>
                                <div className="col-12 mt-3">
                                    <Text className="d-block">Produktet:</Text>
                                    <Transfer
                                        dataSource={products}
                                        showSearch
                                        filterOption={filterOption}
                                        targetKeys={targetKeys}
                                        onChange={handleChange}
                                        onSearch={handleSearch}
                                        render={(item) => item.title}
                                        style={{ width: "100%", minWidth: 500 }}
                                        listStyle={{
                                            width: '48%', // Adjust the width of each list to fit full width
                                        }}
                                    />
                                </div>
                                <div className="col-12 mt-3">
                                    <div className="d-flex justify-content-end">
                                        <Button type="primary" loading={loading} disabled={loading || targetKeys?.length < 1 || !promotion?.title || !promotion?.description || !promotion?.startDate || !promotion?.endDate} onClick={generateProducts}>Gjenero Produktet</Button>

                                      
                                    </div>
                                </div>
                            </div>

                        </form>
                    </Card>
                </div>
                <div className="col-lg-5 mt-lg-0 mt-4">
                    <Card title="Produktet e promocionit">
                        <Table dataSource={selectedProducts} pagination={false} size="small" columns={[{
                            title: 'Emri',
                            dataIndex: 'name',
                            key: 'name'
                        }, {
                            title: 'Cmimi',
                            key: 'pr',
                            render: (_, record) => {
                                return (
                                    <RenderProductPriceInput onChange={(price) => updatePriceByBarcode(record?.barcode, price)} value={record?.price} />
                                )
                            }

                        }]} style={{ width: "100%" }} />

                        <Button type="primary" className="mt-4" loading={loading} disabled={selectedProducts?.length < 1} onClick={savePromotion}>Ruaj promocionin</Button>
                    </Card>
                </div>
            </div>
        </div>
    )
}

export default NewPromotion


const RenderProductPriceInput = ({ onChange, value, }) => {
    return (
        <InputNumber disabled={false} size="small" min={1} onChange={(val) => onChange(val)} value={value} className="quantity-input" style={{ color: "black" }} />
    )
}